import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import _ from 'lodash';

Vue.use(VueGoogleMaps, {
  load: {
    key: _.get(window, 'pageParams.googleApiKey', null),
    libraries: 'places',
  },
});
